var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "14px",
    viewBox: "0 0 17 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter2",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "if_filter_2561439",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(0.000000, 3.000000)",
    stroke: "#6C757D"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 4.65885456 5.43846609 4.65885456 9.19825132 6.98828184 10.3480327 6.98828184 5.43846609 11.6471364 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(9.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-1-link",
    transform: "translate(1.000000, 1.000000)",
    fill: "#6E777E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "4 0.402857143 3.5971429 0 2 1.59714286 0.4028571 0 0 0.402857143 1.5971429 2 0 3.59714286 0.4028571 4 2 2.40285714 3.5971429 4 4 3.59714286 2.4028571 2"
  })), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#F1F5F7",
    points: "4.1099639 3 5.7071068 4.59714286 4.5971429 5.70710678 3 4.10996392 1.4028571 5.70710678 0.29289322 4.59714286 1.8900361 3 0.29289322 1.40285714 1.4028571 0.292893219 3 1.89003608 4.5971429 0.292893219 5.7071068 1.40285714"
  }), /*#__PURE__*/React.createElement("g", {
    id: "path-1-link",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#6C757D",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "4 0.402857143 3.5971429 0 2 1.59714286 0.4028571 0 0 0.402857143 1.5971429 2 0 3.59714286 0.4028571 4 2 2.40285714 3.5971429 4 4 3.59714286 2.4028571 2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFilter);
export default __webpack_public_path__ + "static/media/clear_filter.4ca6bf9d246f3771bd4c93398dbf8e02.svg";
export { ForwardRef as ReactComponent };